var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appendix-section skinc-container"},[_c('AppendixTop'),_c('AppendixBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }